module.exports = __webpack_public_path__ + "assets/img/wechar.f4051f73.jpg";